import { createFileRoute, redirect } from "@tanstack/react-router";

import { isProjectTab, type ProjectTab } from "../components/projects/CmmdProjectTabs";
import { parseTaskSearchParam } from "../components/projects/taskSearchParam";

/**
 * The project page used to live under `/cmmd/`. The prefix said which system
 * the project came from, which is not something a URL needs to announce, so the
 * page moved to `/project/:id`.
 *
 * This shim stays because the old path is already written down elsewhere —
 * agents paste `/cmmd/project/<id>` links straight into CMMD task cards, and
 * those cards outlive the rename.
 *
 * `search` is forwarded, not dropped: the sidebar's settings gear links with
 * `?tab=settings`, and losing it lands the user on the default tab having
 * silently ignored where they asked to go.
 */
export const Route = createFileRoute("/_chat/cmmd/project/$cmmdProjectId")({
  validateSearch: (search: Record<string, unknown>): { task?: string; tab?: ProjectTab } => {
    const task = parseTaskSearchParam(search["task"]);
    const tab = search["tab"];
    return {
      ...(task !== undefined ? { task } : {}),
      ...(isProjectTab(tab) ? { tab } : {}),
    };
  },
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/project/$projectKey",
      params: { projectKey: params.cmmdProjectId },
      search,
      replace: true,
    });
  },
});
